// extracted by mini-css-extract-plugin
export var button = "_ot-0";